var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { TimeEntryType } from "../../time-entries/time-entry-type";
import { PositionDTO } from "./position.dto";
import { safeAssign } from "./safe-assign";
export class TimeEntryPublishedInfoDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Date)
], TimeEntryPublishedInfoDTO.prototype, "time", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Object)
], TimeEntryPublishedInfoDTO.prototype, "deleted", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], TimeEntryPublishedInfoDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeEntryPublishedInfoDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], TimeEntryPublishedInfoDTO.prototype, "positionId", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Object)
], TimeEntryPublishedInfoDTO.prototype, "startPlanned", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Object)
], TimeEntryPublishedInfoDTO.prototype, "endPlanned", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeEntryPublishedInfoDTO.prototype, "comment", void 0);
export class PublishedRosterEmployeeDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PublishedRosterEmployeeDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PublishedRosterEmployeeDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], PublishedRosterEmployeeDTO.prototype, "positions", void 0);
export class PublishedRosterDepartmentDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PublishedRosterDepartmentDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PublishedRosterDepartmentDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PublishedRosterDepartmentDTO.prototype, "color", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PublishedRosterDepartmentDTO.prototype, "order", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], PublishedRosterDepartmentDTO.prototype, "rosterOrder", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], PublishedRosterDepartmentDTO.prototype, "archived", void 0);
__decorate([
    Expose(),
    Type(() => PositionDTO),
    __metadata("design:type", Array)
], PublishedRosterDepartmentDTO.prototype, "positions", void 0);
export class PublishedRosterVenueDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PublishedRosterVenueDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PublishedRosterVenueDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], PublishedRosterVenueDTO.prototype, "enabledHolidays", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PublishedRosterVenueDTO.prototype, "state", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], PublishedRosterVenueDTO.prototype, "departments", void 0);
export class PublishedRosterVenueRefDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PublishedRosterVenueRefDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PublishedRosterVenueRefDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], PublishedRosterVenueRefDTO.prototype, "positionIds", void 0);
export class PublishedRosterTimeEntryDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Date)
], PublishedRosterTimeEntryDTO.prototype, "start", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Object)
], PublishedRosterTimeEntryDTO.prototype, "startPlanned", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Object)
], PublishedRosterTimeEntryDTO.prototype, "endPlanned", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Object)
], PublishedRosterTimeEntryDTO.prototype, "deleted", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PublishedRosterTimeEntryDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], PublishedRosterTimeEntryDTO.prototype, "isPast", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PublishedRosterTimeEntryDTO.prototype, "published", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PublishedRosterTimeEntryDTO.prototype, "positionId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PublishedRosterTimeEntryDTO.prototype, "type", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PublishedRosterTimeEntryDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PublishedRosterTimeEntryDTO.prototype, "days", void 0);
export class PublishedRosterDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PublishedRosterDTO.prototype, "roster", void 0);
__decorate([
    Expose(),
    Type(() => PublishedRosterTimeEntryDTO),
    __metadata("design:type", Array)
], PublishedRosterDTO.prototype, "timeEntries", void 0);
__decorate([
    Expose(),
    Type(() => PublishedRosterEmployeeDTO),
    __metadata("design:type", Array)
], PublishedRosterDTO.prototype, "employees", void 0);
__decorate([
    Expose(),
    Type(() => PublishedRosterVenueRefDTO),
    __metadata("design:type", Array)
], PublishedRosterDTO.prototype, "venues", void 0);
//# sourceMappingURL=published-roster.dto.js.map